<div class="flex flex-col w-full h-full">
        <!-- ── Orange Header (never scrolls) ─────────────────────────────────── -->
        <div class="flex-shrink-0 flex items-center justify-between px-5 py-3 shadow bg-light-orange z-50">
            <h2 class="text-black font-extrabold text-lg uppercase tracking-widest">
                DISTRIBUTOR CHAIN
            </h2>
            <button
                type="button"
                class="material-icons flex items-center custom-btn btn-dark-orange px-4 py-1"
                (click)="closeDialog()">
                close
            </button>
        </div>
        <!-- ── Scrollable Body ───────────────────────────────────────────────── -->
        <div class="modal-body px-5">

                <div class="flex flex-col gap-10" *ngIf="distributorType === 'retailer'">
                    <!-- ── RETAILER ─────────────────────────────────────────────── -->
                    <div>
                        <div style="border-bottom: none;" class="flex items-center justify-center p-2 max-w-xs bg-orange rounded border-none mb-4 mt-4">
                            <span class="font-bold text-white uppercase text-md">Provincial Distributor</span>
                        </div>
                        <div class="flex flex-col rounded rounded-tl-none">
                            <div>
                                <app-data-table
                                    [tableSubHeader]="nonSortableSubHeader"
                                    [isLoading]="isLoading"
                                    [sort_type]="sort_type"
                                    (toggleOnSort)="sortList($event.key, $event.type)">
                                    <tr class="focus:outline-none text-center" *ngFor="let item of retailerPdList">
                                        <td>{{ item.firstName   | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.middleName  | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.lastName    | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.phoneNumber | nullWithDefault }}</td>
                                        <td>{{ item.email       | nullWithDefault }}</td>
                                        <td>{{ item.assignedBy  | nullWithDefault }}</td>
                                        <td>{{ item.assignedDate| nullWithDefault | asiaDate }}</td>
                                    </tr>
                                    <tr *ngIf="!isLoading && retailerPdList.length === 0">
                                        <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-70-px text-gray-500">
                                            <span class="font-semibold text-xs uppercase tracking-wide text-black">No Data Found</span><br>
                                            <span class="italic text-xs text-black">Please try again later.</span>
                                        </td>
                                    </tr>
                                </app-data-table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col gap-10" *ngIf="distributorType === 'regional'">
                    <!-- ── REGIONAL ─────────────────────────────────────────────── -->
                    <div>
                        <div class="flex flex-row justify-between items-center mt-4">
                            <div style="border-bottom: none;" class="flex items-center justify-center p-2 max-w-xs bg-orange rounded border-none" style="min-width: 350px;">
                                <span class="font-bold text-white uppercase text-md">Provincial Distributor</span>
                            </div>
                            <span 
                                class="material-icons text-black text-opacity-50 cursor-pointer text-xl"
                                matTooltip="Refresh"
                                matTooltipClass="custom-orange-tooltip"
                                matTooltipPosition="left"
                                (click)="refresh()">
                                refresh
                            </span>
                        </div>
                        <div class="flex flex-col rounded rounded-tl-none">
                            <div>
                                <div class="flex flex-row justify-between items-center w-full py-2">
                                    <app-limit-control
                                        [currentLimit]="size"
                                        [removePadding]="true"
                                        (limitChangeEvent)="onLimitChangeFromComponent($event)"
                                    ></app-limit-control>
                                    <app-search-control
                                        [searchPlaceholder]="'Search'"
                                        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                                        (keydownEvent)="keyDownFunction($event)"
                                        [removePadding]="true"
                                    ></app-search-control>
                                </div>
                                <app-data-table
                                    [tableSubHeader]="tableSubHeader"
                                    [isLoading]="isLoading"
                                    [sort_type]="sort_type"
                                    (toggleOnSort)="sortList($event.key, $event.type)">
                                    <tr class="focus:outline-none text-center" *ngFor="let item of regionalPdList">
                                        <td>{{ item.firstName   | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.middleName  | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.lastName    | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.phoneNumber | nullWithDefault }}</td>
                                        <td>{{ item.email       | nullWithDefault }}</td>
                                        <td>{{ item.assignedBy  | nullWithDefault }}</td>
                                        <td>{{ item.assignedDate| nullWithDefault | asiaDate }}</td>
                                    </tr>
                                    <tr *ngIf="!isLoading && regionalPdList.length === 0">
                                        <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-70-px text-gray-500">
                                            <span class="font-semibold text-xs uppercase tracking-wide text-black">No Data Found</span><br>
                                            <span class="italic text-xs text-black">Please try again later.</span>
                                        </td>
                                    </tr>
                                </app-data-table>
                            </div>
                            <div class="py-2">
                                <app-pagination
                                    [currentPage]="regionalPd_currentPage"
                                    [totalPages]="regionalPd_totalPages"
                                    [totalItems]="regionalPd_total"
                                    [pageSize]="size"
                                    backgroundColor="bg-white"
                                    [removePadding]="true"
                                    [showTotalEntries]="true"
                                    (pageChange)="setRegionalPdPage($event)"
                                    (previousPage)="prevRegionalPdPage()"
                                    (nextPage)="nextRegionalPdPage()">
                                </app-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col gap-10" *ngIf="distributorType === 'provincial'">
                    <!-- ── PROVINCIAL ─────────────────────────────────────────────── -->
                    <div>
                        <div class="flex flex-row justify-between items-center mt-4">
                            <div style="border-bottom: none;" class="flex items-center justify-center p-2 max-w-xs bg-orange rounded border-none" style="min-width: 350px;">
                                <span class="font-bold text-white uppercase text-md">Regional Distributor</span>
                            </div>
                            <span 
                                class="material-icons text-black text-opacity-50 cursor-pointer text-xl"
                                matTooltip="Refresh"
                                matTooltipClass="custom-orange-tooltip"
                                matTooltipPosition="left"
                                (click)="refresh()">
                                refresh
                            </span>
                        </div>
                        <div class="flex flex-col rounded rounded-tl-none mt-4">
                            <div>
                                <app-data-table
                                    [tableSubHeader]="nonSortableSubHeader"
                                    [isLoading]="isLoading"
                                    [sort_type]="sort_type"
                                    (toggleOnSort)="sortList($event.key, $event.type)">
                                    <tr class="focus:outline-none text-center" *ngFor="let item of provincialRdList">
                                        <td>{{ item.firstName   | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.middleName  | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.lastName    | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.phoneNumber | nullWithDefault }}</td>
                                        <td>{{ item.email       | nullWithDefault }}</td>
                                        <td>{{ item.assignedBy  | nullWithDefault }}</td>
                                        <td>{{ item.assignedDate| nullWithDefault | asiaDate }}</td>
                                    </tr>
                                    <tr *ngIf="!isLoading && provincialRdList.length === 0">
                                        <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-70-px text-gray-500">
                                            <span class="font-semibold text-xs uppercase tracking-wide text-black">No Data Found</span><br>
                                            <span class="italic text-xs text-black">Please try again later.</span>
                                        </td>
                                    </tr>
                                </app-data-table>
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <div style="border-bottom: none;" class="flex items-center justify-center p-2 max-w-xs bg-orange rounded border-none" style="min-width: 350px;">
                            <span class="font-bold text-white uppercase text-md">Retailers</span>
                        </div>
                        <div class="flex flex-col rounded rounded-tl-none">
                            <div>
                                <div class="flex flex-row justify-between items-center w-full py-2">
                                    <app-limit-control
                                        [currentLimit]="size"
                                        [removePadding]="true"
                                        (limitChangeEvent)="onLimitChangeFromComponent($event)"
                                    ></app-limit-control>
                                    <app-search-control
                                        [searchPlaceholder]="'Search'"
                                        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                                        (keydownEvent)="keyDownFunction($event)"
                                        [removePadding]="true"
                                    ></app-search-control>
                                </div>
                                <app-data-table
                                    [tableSubHeader]="tableSubHeader"
                                    [isLoading]="isLoading"
                                    [sort_type]="sort_type"
                                    (toggleOnSort)="sortList($event.key, $event.type)">
                                    <tr class="focus:outline-none text-center" *ngFor="let item of provincialRtList">
                                        <td>{{ item.firstName   | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.middleName  | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.lastName    | nullWithDefault | titlecase }}</td>
                                        <td>{{ item.phoneNumber | nullWithDefault }}</td>
                                        <td>{{ item.email       | nullWithDefault }}</td>
                                        <td>{{ item.assignedBy  | nullWithDefault }}</td>
                                        <td>{{ item.assignedDate| nullWithDefault | asiaDate }}</td>
                                    </tr>
                                    <tr *ngIf="!isLoading && provincialRtList.length === 0">
                                        <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-70-px text-gray-500">
                                            <span class="font-semibold text-xs uppercase tracking-wide text-black">No Data Found</span><br>
                                            <span class="italic text-xs text-black">Please try again later.</span>
                                        </td>
                                    </tr>
                                </app-data-table>
                            </div>
                            <div class="py-2">
                                <app-pagination
                                    [currentPage]="provincialRt_currentPage"
                                    [totalPages]="provincialRt_totalPages"
                                    [totalItems]="provincialRt_total"
                                    [pageSize]="size"
                                    backgroundColor="bg-white"
                                    [removePadding]="true"
                                    [showTotalEntries]="true"
                                    (pageChange)="setProvincialRtPage($event)"
                                    (previousPage)="prevProvincialRtPage()"
                                    (nextPage)="nextProvincialRtPage()">
                                </app-pagination>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
</div>